export default [
    { name: 'Устройства', icon: 'mdi-file', route: '/admin/device/index' },
]
